module.exports = __webpack_public_path__ + "static/img/exhibitFormTips3.dff86e46.png";